import { decodeFCompositionId, FCompositionTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { FArrangement } from '../farrangements/types.js';
import { FCompositionNode, FNode, FNodeTypesEnum } from '../types/index.js';

export const isFArrangementNode = (node: FNode): node is FCompositionNode<FArrangement> => {
  return (
    node.type === FNodeTypesEnum.FComposition &&
    decodeFCompositionId(node.id).type === FCompositionTypesEnum.FArrangement
  );
};
